"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const assert = require('assert').strict;
const { resolveExpression } = require('../evaluate');
const { BETWEEN } = require('../definitions/operators');
const { generateDateAfterExpression, generateDateBeforeExpression, generateAndExpression, } = require('../definitions/factory/expressionFactory');
exports.accepts = ({ operator }) => operator === BETWEEN;
exports.resolve = ({ right, left }, context) => __awaiter(void 0, void 0, void 0, function* () {
    assert(context);
    assert(right);
    assert(left);
    const { context: { before }, } = right;
    assert(before);
    const leftResolved = yield resolveExpression(left, context);
    const afterResolved = yield resolveExpression(right, context);
    const beforeResolved = yield resolveExpression(before, context);
    const afterExpression = generateDateAfterExpression({
        leftValue: leftResolved,
        afterValue: afterResolved,
    });
    const beforeExpression = generateDateBeforeExpression({
        leftValue: leftResolved,
        beforeValue: beforeResolved,
    });
    const expression = generateAndExpression({
        operands: [afterExpression, beforeExpression],
    });
    return resolveExpression(expression, context);
});
//# sourceMappingURL=betweenExpression.js.map